import React from 'react';
import styled from 'styled-components';

import { breakpoints, colors } from '../../constants';
import { PackageTitleStars } from '../PackageTitleStars';

interface IProps {
    starAmount: number;
    className?: string;
}

const BasePackageNameDisplay: React.FC<IProps> = ({
    starAmount,
    className,
}) => (
    <div className={className}>
        <h3>
            Glaspakket <PackageTitleStars starAmount={starAmount} />
        </h3>
    </div>
);

export const PackageNameDisplay = styled(BasePackageNameDisplay)`
    font-size: 2.4rem;
    line-height: 1;

    @media (${breakpoints.mediumMin}) {
        margin-bottom: 0;
    }

    h3 {
        font-size: 20px;
        color: ${colors.greenDark};
    }

    ${PackageTitleStars} {
        margin-left: 8px;
    }
`;
